import React, { useEffect, useState } from 'react';
import { Box, Container, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Switch } from '@mui/material';
import { toast } from 'react-toastify';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';
import { useUser } from '../../userContext';
import { ExpirationDate } from '../admin/metrics'
import UserPwModal from '../admin/modals/users/userPwModal';
import UserProfileModal from './modals/userProfile/userProfileModal';

const UsersProfileTable = ({ items, fetchUsers, setUsers }) => {
  const userId = useUser();
  const handleUpdate = (user) =>  {    
    toast.success(`${user.username} Updated`, { autoClose: 3000 });
    fetchUsers();
  };

  const handlePWUpdate = (user) =>  {    
    toast.success(`Password Updated For ${user.username} `, { autoClose: 3000 });
  };

  const getUser = (arr) => {
    return arr.find(u => u.id === userId.userId);
  }

  return (
    <>
      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">    
          <TableHead>
          <TableRow sx={{ backgroundColor: '#0568AE' }}>
              <TableCell sx={{ color: '#EEEEEE', fontWeight: 'bold' }}>User Name</TableCell>
              <TableCell sx={{ color: '#EEEEEE', fontWeight: 'bold' }}>First Name</TableCell>
              <TableCell sx={{ color: '#EEEEEE', fontWeight: 'bold' }}>Last Name</TableCell>
              <TableCell sx={{ color: '#EEEEEE', fontWeight: 'bold' }}>Email Address</TableCell>
              <TableCell sx={{ color: '#EEEEEE', fontWeight: 'bold' }}>Phone Number</TableCell>
              <TableCell sx={{ color: '#EEEEEE', fontWeight: 'bold' }}>Expiration Date</TableCell>
              <TableCell sx={{ color: '#EEEEEE', fontWeight: 'bold' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {getUser(items) && (
              <TableRow key={getUser(items).id} sx={{ height: 56, backgroundColor : '#2A2A2A' }}>
                <TableCell sx={{ color: '#FFFFFF' }}>{getUser(items).username}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{getUser(items).firstname}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{getUser(items).lastname}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{getUser(items).emailaddr}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{getUser(items).phone}</TableCell> 
                <TableCell sx={{ color: '#FFFFFF' }}>{ExpirationDate(getUser(items).registration_dt, true)}</TableCell> 
                <TableCell>
                    <Stack direction="row" spacing={1}>
                        <UserPwModal user={getUser(items)} onTriggerPWUpdate={handlePWUpdate} />
                        <UserProfileModal user={getUser(items)} onTriggerUpdate={handleUpdate} />
                    </Stack>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
  
  export default function UserProfile() {
    const [users, setUsers] = useState([]);
    const userId = useUser();

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {   
          const response = await fetch(`${process.env.REACT_APP_API}/users/`);            
          if (!response.ok) {
              toast.error(`HTTP error! status: ${response.status}`);
          } else {
              const json = await response.json();
              setUsers(json.data);
          }
        } catch (error) {
          toast.error(error);
        } 
    };
    
    

    const handleCreate = (user) =>  {
      toast.success(`${user.username} Created`, { autoClose: 3000 });
      fetchUsers();
    };


    const handleUpdate = async (user) => {
      if ( user.disabled ) {
          user.cli = false;
      }
      const res = await fetch(`${process.env.REACT_APP_API}/users/update`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(user)
      });
      if (!res.ok) {
        toast.error(`Failed to update user : ${res.status}`);
      } else {
        
        const userId = user.id;
        setUsers((prev) => prev.map((p) => (p.id === user.id ? user : p)));
      }
      };
      
    return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
        <Box sx={{pt: 2, marginBottom: '-50px'}}>
            <ClassificationBannerHeader />
            <PageHeader title="User Profile" />
            <TableContainer component={Paper} sx={{ mt: 4, backgroundColor: '#1A1A1A'  }}>
                <UsersProfileTable
                    items={users}
                    fetchUsers={fetchUsers}
                    setUsers={setUsers}
                />
            </TableContainer>
            <UserProfileModal user='' onTriggerUpdate={handleUpdate} />
        </Box>
    </Container>
  )
}
  